import '.cd{flex-shrink:0;}.ssr-plugin'
import '.ce{padding:1rem;}.ssr-plugin'
import '.t{width:100%;}.ssr-plugin'
import '.bw{height:100%;}.ssr-plugin'
import '.b3{border:none;}.ssr-plugin'
import '.b4{background-color:transparent;}.ssr-plugin'
import '.ev{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ak{align-items:stretch;}.ssr-plugin'
import '.bj{position:sticky;}.ssr-plugin'
import '.ew{top:4rem;}.ssr-plugin'
import '.ex{z-index:7;}.ssr-plugin'
import '.aq{background-color:var(--shades-white);}.ssr-plugin'
import '.ey{padding-bottom:1rem;}.ssr-plugin'
import '.m{margin-bottom:1rem;}.ssr-plugin'
import '.ez{border-bottom:var(--blue-border);}.ssr-plugin'
import '.q{position:fixed;}.ssr-plugin'
import '.bk{top:0px;}.ssr-plugin'
import '.c0{left:0px;}.ssr-plugin'
import '.c1{right:0px;}.ssr-plugin'
import '.f0{bottom:0px;}.ssr-plugin'
import '.et{z-index:9999;}.ssr-plugin'
import '.f1{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.dr{justify-content:flex-end;}.ssr-plugin'
import '.cf{flex:1;}.ssr-plugin'
import '.ax{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="cd ce t bw b3 b4 ev"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ak"
    >
      <div className="bj ew ex aq ey m ez a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="q bk c0 c1 f0 et aq f1 a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="ce a dr ez"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="cf ax">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
